import InputField from 'components/InputField'
import { getAvailabilityDetails, getManageStaffDetailsById } from 'core/services/api'
import { MocUserRole } from 'core/services/models/Enums'
import React, { useState, useEffect } from 'react'
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import "./MyProfile.scss"
import moment from 'moment'

export default function MyProfile() {
    const slots = {
        Monday: {
            mondayMorningStartTime: "",
            mondayMorningEndTime: "",
            mondayAfternoonStartTime: "",
            mondayAfternoonEndTime: "",
            mondayEveningStartTime: "",
            mondayEveningEndTime: "",
        },
        Tuesday: {
            tuesdayMorningStartTime: "",
            tuesdayMorningEndTime: "",
            tuesdayAfternoonStartTime: "",
            tuesdayAfternoonEndTime: "",
            tuesdayEveningStartTime: "",
            tuesdayEveningEndTime: "",
        },
        Wednesday: {
            wednesdayMorningStartTime: "",
            wednesdayMorningEndTime: "",
            wednesdayAfternoonStartTime: "",
            wednesdayAfternoonEndTime: "",
            wednesdayEveningStartTime: "",
            wednesdayEveningEndTime: "",
        },
        Thursday: {
            thursdayMorningStartTime: "",
            thursdayMorningEndTime: "",
            thursdayAfternoonStartTime: "",
            thursdayAfternoonEndTime: "",
            thursdayEveningStartTime: "",
            thursdayEveningEndTime: "",
        },
        Friday: {
            fridayMorningStartTime: "",
            fridayMorningEndTime: "",
            fridayAfternoonStartTime: "",
            fridayAfternoonEndTime: "",
            fridayEveningStartTime: "",
            fridayEveningEndTime: "",
        },

        Saturday: {
            saturdayMorningStartTime: "",
            saturdayMorningEndTime: "",
            saturdayAfternoonStartTime: "",
            saturdayAfternoonEndTime: "",
            saturdayEveningStartTime: "",
            saturdayEveningEndTime: "",
        },

        Sunday: {
            sundayMorningStartTime: "",
            sundayMorningEndTime: "",
            sundayAfternoonStartTime: "",
            sundayAfternoonEndTime: "",
            sundayEveningStartTime: "",
            sundayEveningEndTime: "",
        },
    }
    const slotDuration: string[] = [
        "Morning Slot",
        "Afternoon Slot",
        "Evening Slot",
    ]

    const allowed = [
        MocUserRole?.CONSULTANT,
        MocUserRole?.GENETIC_COUNSELLOR,
        MocUserRole?.HOME_CARE_NURSE,
        MocUserRole?.HOME_CARE_RMO,
        MocUserRole?.NUTRITIONIST,
        MocUserRole?.PHYSIOTHERAPIST,
        MocUserRole?.PSYCHOLOGIST,
    ]

    const userDetail = useSelector((state: any) => state?.user?.userDetail)
    const userRole = useSelector((state: any) => state?.user?.role)
    const history = useHistory()
    const [manageStaffInfo, setManageStaffInfo] = useState<any>()
    const [avaialbilityResult, setAvaialbilityResult] = useState<any>()
    const [availabilitySlots, setAvailabilitySlots] = useState<any>(slots)

    useEffect(() => {
        if (userDetail?.id) {
            getManageStaffDetailsById(userDetail?.id)
                .then((res: any) => {
                    setManageStaffInfo(res)
                })
                .catch((err: any) => console.log(err?.message))
        }
    }, [])

    useEffect(() => {
        if (
            !(manageStaffInfo?.primaryRole === "SYSTEM_ADMIN" ||
                manageStaffInfo?.primaryRole === "MRD" ||
                manageStaffInfo?.primaryRole === "MARKETING" ||
                manageStaffInfo?.primaryRole === "QUALITY" ||
                manageStaffInfo?.primaryRole === "INSURANCE" ||
                manageStaffInfo?.primaryRole === "ACCOUNTANT" ||
                manageStaffInfo?.primaryRole === "OPERATIONS" ||
                manageStaffInfo?.primaryRole === "MANAGEMENT")
        ) {
            fetchAvailabilityDetails()

        }
    }, [manageStaffInfo])

    const fetchAvailabilityDetails = () => {
        if (manageStaffInfo?.id && manageStaffInfo?.centers[0]?.centerId) {
            getAvailabilityDetails(
                manageStaffInfo?.centers[0]?.centerId,
                manageStaffInfo?.id
            )
                .then((res) => {
                    setAvaialbilityResult(res[0])
                    if (res[0]?.availabilityTimeFrame) {
                        if (Object.keys(res[0]?.availabilityTimeFrame).length > 0) {
                            updateAvailabilitySlots(res[0]?.availabilityTimeFrame)
                        }
                    } else if (res?.length === 0) {
                        setAvailabilitySlots(slots)
                    }
                })
                .catch((err) => {
                    console.log("Err", err)
                })
        }
    }

    const updateAvailabilitySlots = (slotsObj: any) => {
        //Monday
        const mondayMorningObj = slotsObj?.MONDAY_MORNING?.split("-")
        const mondayAfternoonObj = slotsObj?.MONDAY_AFTERNOON?.split("-")
        const mondayEveningObj = slotsObj?.MONDAY_EVENING?.split("-")
        //Tuesday
        const tuesdayMorningObj = slotsObj?.TUESDAY_MORNING?.split("-")
        const tuesdayAfternoonObj = slotsObj?.TUESDAY_AFTERNOON?.split("-")
        const tuesdayEveningObj = slotsObj?.TUESDAY_EVENING?.split("-")
        //Wednesday
        const wednesdayMorningObj = slotsObj?.WEDNESDAY_MORNING?.split("-")
        const wednesdayAfternoonObj = slotsObj?.WEDNESDAY_AFTERNOON?.split("-")
        const wednesdayEveningObj = slotsObj?.WEDNESDAY_EVENING?.split("-")
        //Thursday
        const thursdayMorningObj = slotsObj?.THURSDAY_MORNING?.split("-")
        const thursdayAfternoonObj = slotsObj?.THURSDAY_AFTERNOON?.split("-")
        const thursdayEveningObj = slotsObj?.THURSDAY_EVENING?.split("-")
        //Friday
        const fridayMorningObj = slotsObj?.FRIDAY_MORNING?.split("-")
        const fridayAfternoonObj = slotsObj?.FRIDAY_AFTERNOON?.split("-")
        const fridayEveningObj = slotsObj?.FRIDAY_EVENING?.split("-")
        //Saturday
        const saturdayMorningObj = slotsObj?.SATURDAY_MORNING?.split("-")
        const saturdayAfternoonObj = slotsObj?.SATURDAY_AFTERNOON?.split("-")
        const saturdayEveningObj = slotsObj?.SATURDAY_EVENING?.split("-")
        //Sunday
        const sundayMorningObj = slotsObj?.SUNDAY_MORNING?.split("-")
        const sundayAfternoonObj = slotsObj?.SUNDAY_AFTERNOON?.split("-")
        const sundayEveningObj = slotsObj?.SUNDAY_EVENING?.split("-")

        setAvailabilitySlots({
            Monday: {
                mondayMorningStartTime: mondayMorningObj[0],
                mondayMorningEndTime: mondayMorningObj[1],
                mondayAfternoonStartTime: mondayAfternoonObj[0],
                mondayAfternoonEndTime: mondayAfternoonObj[1],
                mondayEveningStartTime: mondayEveningObj[0],
                mondayEveningEndTime: mondayEveningObj[1],
            },
            Tuesday: {
                tuesdayMorningStartTime: tuesdayMorningObj[0],
                tuesdayMorningEndTime: tuesdayMorningObj[1],
                tuesdayAfternoonStartTime: tuesdayAfternoonObj[0],
                tuesdayAfternoonEndTime: tuesdayAfternoonObj[1],
                tuesdayEveningStartTime: tuesdayEveningObj[0],
                tuesdayEveningEndTime: tuesdayEveningObj[1],
            },
            Wednesday: {
                wednesdayMorningStartTime: wednesdayMorningObj[0],
                wednesdayMorningEndTime: wednesdayMorningObj[1],
                wednesdayAfternoonStartTime: wednesdayAfternoonObj[0],
                wednesdayAfternoonEndTime: wednesdayAfternoonObj[1],
                wednesdayEveningStartTime: wednesdayEveningObj[0],
                wednesdayEveningEndTime: wednesdayEveningObj[1],
            },
            Thursday: {
                thursdayMorningStartTime: thursdayMorningObj[0],
                thursdayMorningEndTime: thursdayMorningObj[1],
                thursdayAfternoonStartTime: thursdayAfternoonObj[0],
                thursdayAfternoonEndTime: thursdayAfternoonObj[1],
                thursdayEveningStartTime: thursdayEveningObj[0],
                thursdayEveningEndTime: thursdayEveningObj[1],
            },
            Friday: {
                fridayMorningStartTime: fridayMorningObj[0],
                fridayMorningEndTime: fridayMorningObj[1],
                fridayAfternoonStartTime: fridayAfternoonObj[0],
                fridayAfternoonEndTime: fridayAfternoonObj[1],
                fridayEveningStartTime: fridayEveningObj[0],
                fridayEveningEndTime: fridayEveningObj[1],
            },

            Saturday: {
                saturdayMorningStartTime: saturdayMorningObj[0],
                saturdayMorningEndTime: saturdayMorningObj[1],
                saturdayAfternoonStartTime: saturdayAfternoonObj[0],
                saturdayAfternoonEndTime: saturdayAfternoonObj[1],
                saturdayEveningStartTime: saturdayEveningObj[0],
                saturdayEveningEndTime: saturdayEveningObj[1],
            },

            Sunday: {
                sundayMorningStartTime: sundayMorningObj[0],
                sundayMorningEndTime: sundayMorningObj[1],
                sundayAfternoonStartTime: sundayAfternoonObj[0],
                sundayAfternoonEndTime: sundayAfternoonObj[1],
                sundayEveningStartTime: sundayEveningObj[0],
                sundayEveningEndTime: sundayEveningObj[1],
            },
        })
    }

    return (
        <div className='my-profile-container'>
            <div
                className="approval-back-image"
                onClick={() => {
                    history.goBack()
                }}
            >
                <img
                    src={"../../../assets/images/back-icon.svg"}
                    height={"60px"}
                    width={"60px"}
                    alt="back button"
                    className="back_button"
                />
                <span className="edit-manage-staff-heading" style={{
                    fontWeight: 600
                }}>Back</span>
            </div>
            <form>
                <div className="edit-details-wrapper">
                    <div className="edit-details-container">
                        <div className="manage-staff-details">
                            <div className="col-md-6 col-lg-6 staff_details">
                                <div>
                                    <label className="textlabel">Staff Name:</label>
                                </div>
                                <InputField
                                    className="col-md-8"
                                    placeholder=""
                                    value={manageStaffInfo?.name}
                                    handleChange={(e) => { }}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-md-6 col-lg-6 staff_details">
                                <div>
                                    <label className="textlabel">Phone:</label>
                                </div>
                                <InputField
                                    className="col-md-8"
                                    placeholder=""
                                    value={manageStaffInfo?.phoneNumber}
                                    handleChange={(e) => { }}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-md-6 col-lg-6 staff_details">
                                <div>
                                    <label className="textlabel">MOC Email:</label>
                                </div>
                                <InputField
                                    className="col-md-8"
                                    placeholder=""
                                    value={manageStaffInfo?.email}
                                    handleChange={(e) => { }}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-md-6 col-lg-6 staff_details">
                                <div>
                                    <label className="textlabel">Primary Role:</label>
                                </div>
                                <InputField
                                    className="col-md-8"
                                    placeholder=""
                                    value={manageStaffInfo?.primaryRole}
                                    handleChange={(e) => { }}
                                    readOnly={true}
                                />
                            </div>
                            <div className="col-md-6 col-lg-6 staff_details_multiple_values">
                                <div>
                                    <label className="textlabel">Secondary Roles:
                                    </label>
                                </div>
                                <div className="col-md-8 col-lg-8">
                                    <ul>
                                        {
                                            manageStaffInfo?.secondaryRoles?.map((role: any) => {
                                                return <li>{role?.split("_")?.join(" ")}</li>
                                            })
                                        }
                                    </ul>
                                </div>
                            </div>
                            {
                                !(
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.ACCOUNTANT) ||
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.QUALITY) ||
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.MARKETING) ||
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.INSURANCE) ||
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.SYSTEM_ADMIN) ||
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.OPERATIONS) ||
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.MANAGEMENT) ||
                                    manageStaffInfo?.primaryRole.includes(MocUserRole.MRD)
                                ) && (
                                    <div className="col-md-6 col-lg-6 staff_details_multiple_values">
                                        <div>
                                            <label className="textlabel">Location:</label>
                                        </div>
                                        <div className="col-md-8 col-lg-8">
                                            <ul>
                                                {
                                                    manageStaffInfo?.centers?.map((center: any) => {
                                                        return <li>{center?.centerName}</li>
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                allowed?.includes(userRole) && (
                                    <>
                                        <div className="col-md-6 col-lg-6 staff_details">
                                            <div>
                                                <label className="textlabel">Specialization:</label>
                                            </div>
                                            <InputField
                                                className="col-md-8"
                                                placeholder="Specialization"
                                                value={manageStaffInfo?.specialization}
                                                handleChange={(e) => { }}
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-6 staff_details">
                                            <div>
                                                <label className="textlabel">Start Date Of Practice:</label>
                                            </div>
                                            <InputField
                                                className="col-md-8"
                                                placeholder="Start Date Of Practice"
                                                value={moment(manageStaffInfo?.startDateOfPractice
                                                ).format("DD-MM-YYYY")}
                                                handleChange={(e) => { }}
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="col-md-6 col-lg-6 staff_details">
                                            <div>
                                                <label className="textlabel">
                                                    Start Date Of Speciality Practice:
                                                </label>
                                            </div>
                                            <InputField
                                                className="col-md-8"
                                                placeholder="Start Date Of Speciality Practice"
                                                value={moment(manageStaffInfo?.startDateOfSpecialityPractice
                                                ).format("DD-MM-YYYY")}
                                                handleChange={(e) => { }}
                                                readOnly={true}
                                            />
                                        </div>
                                        {!(manageStaffInfo?.primaryRole.includes(MocUserRole.GENETIC_COUNSELLOR) ||
                                            manageStaffInfo?.primaryRole.includes(MocUserRole.NUTRITIONIST) ||
                                            manageStaffInfo?.primaryRole.includes(MocUserRole.PSYCHOLOGIST) ||
                                            manageStaffInfo?.primaryRole.includes(MocUserRole.CONSULTANT) ||
                                            manageStaffInfo?.primaryRole.includes(MocUserRole.HOME_CARE_RMO) ||
                                            manageStaffInfo?.primaryRole.includes(MocUserRole.HOME_CARE_NURSE) ||
                                            manageStaffInfo?.primaryRole.includes(MocUserRole.PHYSIOTHERAPIST)) && (
                                                <>
                                                    <div className="availability-timings">
                                                        <div className="row">
                                                            <div className="col-1 textlabel">Availability timings:</div>
                                                            <div className="col-10 slot-duration">
                                                                {slotDuration?.map((eachTime: any) => (
                                                                    <div>{eachTime}</div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        {Object.keys(availabilitySlots)?.map((eachDay: any) => {
                                                            return (
                                                                <div>
                                                                    <div className="row section">
                                                                        <div className="col-1 textlabel">{eachDay}</div>
                                                                        <div className="col-10 slot-timings">
                                                                            <div className="row">
                                                                                {Object.keys(availabilitySlots[eachDay]).map(
                                                                                    (ele: any) => {
                                                                                        return (
                                                                                            <div className="col-2">
                                                                                                <InputField
                                                                                                    className="col-md-12 time-picker"
                                                                                                    placeholder="From time"
                                                                                                    value={availabilitySlots[eachDay][ele]}
                                                                                                    type="time"
                                                                                                    handleChange={(e) => { }}
                                                                                                    readOnly={true}
                                                                                                />
                                                                                            </div>
                                                                                        )
                                                                                    }
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </>)
                                        }

                                    </>
                                )
                            }
                        </div>
                    </div >
                </div >
            </form >
        </div >
    )
}
